import NoPage from '../pages/NoPage';
import Admin from '../middlewares/Admin';
import AdminLayout from '../layouts/AdminLayout';
import VerifiedMember from '../middlewares/VerifiedMember';
import Dashboard from '../pages/admin/Dashboard';
import Cases from '../pages/admin/Cases';
import CaseDetail from '../pages/admin/CaseDetail';
import Transactions from '../pages/admin/Transactions';
import Proceedings from '../pages/admin/Proceedings';
import Users from '../pages/admin/Users';
import { getUserData, getUsers } from '../adapters/users';
import { getTransactions } from '../adapters/transaction';
import { proceedings } from '../adapters/proceedings';
import { getCaseDetail, getCases } from '../adapters/caseResolution';
import User from '../pages/admin/User';
import { getAdminData } from '../adapters/dash';
import { getAuthenticatedUser, getAuthToken } from '../adapters/authentication';

const adminGuard = () => {
    const token = getAuthToken();
    const isAuthenticated = token !== null && token !== undefined;
    const authenticatedUser = getAuthenticatedUser();
    const isAdmin = authenticatedUser.role === 1;
    return isAuthenticated && isAdmin
}

export const adminRoutes = [
    {
        path: "/admin",
        element: <VerifiedMember>
            <Admin>
                <AdminLayout />
            </Admin>
        </VerifiedMember>,   
        errorElement: <NoPage />,
        children: [
            {
                path: "dashboard",
                element: <Dashboard />,
                loader: async () => {
                    try {
                        if(adminGuard()){
                            const data = await getAdminData().then(res => res.data);
                            return data;
                        }
                        return 
                    } catch (e) {
                        throw new Response("Not Found", {
                            status: 503
                        });
                    }
                }
            },

            {
                path: "cases",
                element: <Cases /> ,
                loader: async () => {
                    try {
                         if (adminGuard()) {
                            const data = await getCases().then((res) => res.data)
                            return data;
                         }
                         return 
                    } catch (e) {
                        throw new Response("Not Found", {
                            status: 503
                        });
                    }
                }
            },
            {
                path: "case-detail/:id",
                element: <CaseDetail />,
                loader: async ({params}) => {
                     if (adminGuard()) {
                        const caseDetail = await getCaseDetail(params.id).then((res) => {
                            if (res.status === 200) {
                                return res.data
                            } else {
                                throw new Response("Not Found", {
                                    status: 404
                                });
                            }
                        })
                        return caseDetail;
                    }
                    return
                }
            },
            {
                path: "users/",
                element: <Users type="basic" /> ,
                loader: async ({
                    params
                }) => {
                    try {
                        if (adminGuard()) {
                            const users = await getUsers(1).then((res) => res.data)
                            return users
                        }
                        return
                    } catch (e) {
                        throw new Response("Not Found", {
                            status: 503
                        });
                    }
                }
            },
            {
                path: "neutrals/",
                element: <Users type="neutral" /> ,
                loader: async ({
                    params
                }) => {
                    try {
                        if(adminGuard()){
                            const users = await getUsers(1, 'neutral').then((res) => res.data)
                            return users
                        }
                        return
                    } catch (e) {
                        throw new Response("Not Found", {
                            status: 503
                        });
                    }
                }
            },
            {
                path: "user/:id",
                element: <User /> ,
                loader: async ({
                    params
                }) => {
                    try {
                         if(adminGuard()){
                            const data = await getUserData(params.id).then((res) => res.data)
                            return data
                         }
                         return
                    } catch (e) {
                        throw new Response("Not Found", {
                            status: 503
                        });
                    }
                }
            },
            {
                path: "proceedings/",
                element: <Proceedings /> ,
                loader: async ({
                    params
                }) => {
                    try {
                         if(adminGuard()){
                            const data = await proceedings().then(res => res.data)
                            return data;
                         }
                         return
                    } catch (e) {
                        throw new Response("Not Found", {
                            status: 503
                        });
                    }
                }
            },
            {
                path: "transactions/",
                element: <Transactions /> ,
                loader: async ({
                    params
                }) => {
                    try {
                         if(adminGuard()){
                            const transactions = await getTransactions(1).then((res) => res.data)
                            return transactions
                         }
                         return 
                    } catch (e) {
                        throw new Response("Not Found", {
                            status: 503
                        });
                    }
                }
            },
        ]
    }
];